import { useState } from "react";
import {
  RequestUpdateSettingRequest,
  SettingUpdateSettingPostRequest,
  SettingApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateBaseSetting = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateBaseSetting = async (req: RequestUpdateSettingRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: SettingUpdateSettingPostRequest = {
        req,
      };

      const api = new SettingApi(config);
      const response = await api.settingUpdateSettingPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateBaseSetting, error, isLoading };
};
